import { Button } from "@/components/shadcn/button";
import { LoadingButton } from "../../components/ui/Button";
import { TextInput } from "../../components/ui/form/TextInput";
import useLogin from "../../services/auth/useLogin";
import { useNavigate } from "@solidjs/router";

export default function Login() {

  const { loading, form, onLogin, onSubmit, onFormInput } = useLogin();
  const navigate = useNavigate();

  const navigateToForgetPassword = () => {
    navigate("/auth/forget-password", { replace: true });
  }

  return (
    <div class="space-y-6">
      <div class="flex flex-col space-y-2 text-center">
        <h1 class="text-2xl font-semibold tracking-tight">
          Welcome
        </h1>
        <p class="text-sm text-muted-foreground">
          Login to your account
        </p>
      </div>
      <div class="grid gap-6">
        <form onSubmit={onSubmit}>
          <div class="grid gap-2 gap-y-4">
            <div class="grid gap-1">
              <TextInput
                type="text"
                name="identity"
                form={form}
                loading={loading()}
                input={onFormInput}
                label='Email or Username'
                placeholder="Email or Username" />
            </div>
            <div class="grid gap-1">
              <TextInput
                type="password"
                name="password"
                form={form}
                loading={loading()}
                input={onFormInput}
                submitOnEnter={true}
                submit={() => { onLogin() }}
                label='Password'
                placeholder="Password" />
            </div>
            <div class="grid gap-1 mt-[5px]">
              <LoadingButton onClick={(e) => { onLogin() }} loading={loading()}>Login to System</LoadingButton>
            </div>
          </div>
        </form>
        <div class="inset-0 flex items-center">
          <span class="w-full border-t" />
        </div>
        <Button variant="outline" onClick={() => { navigateToForgetPassword() }} type="button" disabled={loading()}>
          Forget Password?
        </Button>
      </div>
    </div>
  )
}
